module.exports = __webpack_public_path__ + "img/bbc-world-service.3151dc44.png";